module.exports = __webpack_public_path__ + "static/assets/27557abca597bafded7f45adede9a6bf.svg";